import axios from 'axios';
import * as CryptoJS from 'crypto-js';

const baseURL = `${process.env.REACT_APP_API_URL}/accounts/index.php`;
let CryptoJSAesJson = {
    /**
     * Encrypt any value
     * @param {*} value
     * @param {string} password
     * @return {string}
     */
    'encrypt': function (value, password) {
        return CryptoJS.AES.encrypt(JSON.stringify(value), password, { format: CryptoJSAesJson }).toString()
    },
    /**
     * Decrypt a previously encrypted value
     * @param {string} jsonStr
     * @param {string} password
     * @return {*}
     */
    'decrypt': function (jsonStr, password) {
        return JSON.parse(CryptoJS.AES.decrypt(jsonStr, password, { format: CryptoJSAesJson }).toString(CryptoJS.enc.Utf8))
    },
    /**
     * Stringify cryptojs data
     * @param {Object} cipherParams
     * @return {string}
     */
    'stringify': function (cipherParams) {
        var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) }
        if (cipherParams.iv) j.iv = cipherParams.iv.toString()
        if (cipherParams.salt) j.s = cipherParams.salt.toString()
        return JSON.stringify(j).replace(/\s/g, '')
    },
    /**
     * Parse cryptojs data
     * @param {string} jsonStr
     * @return {*}
     */
    'parse': function (jsonStr) {
        var j = JSON.parse(jsonStr)
        var cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(j.ct) })
        if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
        if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
        return cipherParams
    }
}

export const forgetPasswordService = {
    checkEmail,
    verifyOTP,
    resendOTP,
    resetPassword,
    updatePassword
};

async function checkEmail(email) {
    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    var encrypted = CryptoJSAesJson.encrypt(email, password);

    return await axios.post(`${baseURL}?type=8`, encrypted)
        .then(response => response.data)
        .catch(err => console.log(err));
}

async function verifyOTP(userID, otp) {
    let data = {
        userID : userID,
        pin : otp
    }
    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    var encrypted = CryptoJSAesJson.encrypt(data, password);

    return await axios.post(`${baseURL}?type=3`, encrypted)
        .then(response => response.data)
        .catch(err => console.log(err));
}

async function resendOTP(userID = '', email) {
    let data = {
        userID : userID,
        email : email
    }
    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    var encrypted = CryptoJSAesJson.encrypt(data, password);

    return await axios.post(`${baseURL}?type=7`, encrypted)
        .then(response => response.data)
        .catch(err => console.log(err));
}

async function resetPassword(userID, password1, password2, token) {
    let data = {
        individualID: userID,
        password1: password1,
        password2: password2,
        token : token
    }

    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    var encrypted = CryptoJSAesJson.encrypt(data, password);

    return await axios.post(`${baseURL}?type=9`, encrypted)
        .then(response => response.data)
        .catch(err => console.log(err));
}

async function updatePassword(userID, currentPassword, password1, password2, token) {
    let data = {
        individualID: userID,
        currentPassword: currentPassword,
        password1: password1,
        password2: password2,
        token : token
    }

    // console.log(data);

    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    var encrypted = CryptoJSAesJson.encrypt(data, password);

    // console.log(encrypted);

    return await axios.post(`${baseURL}?type=10`, encrypted)
        .then(response => response.data)
        .catch(err => console.log(err));
}